import axios from 'axios';

/**
 * Taken from https://github.com/kennethjiang/js-file-download/blob/master/file-download.js
 * @param data
 * @param filename
 * @param mime
 * @param bom
 */
function downloadFileFromData(data, filename, mime, bom) {
  var blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
  var blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
  } else {
    var blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function () {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 0);
  }
}

/**
 * Initiates a file download with axios (XHR) - adding default Authorization header and allowing to access secure file endpoints.
 * Then turning the response in to object URL
 * @param url
 * @returns {Promise<void>} - initiates browser file download dialogue.
 */
const downloadFile = async (url) => {
  const res = await axios.get(url, { responseType: 'blob' });
  const contentType = res.headers['content-type'];
  const cd = res.headers['content-disposition'];
  const fileName = cd ? cd.substring(cd.indexOf('filename=') + 9) : 'essentialsDownloadedFile';
  downloadFileFromData(res.data, fileName, contentType);
};

export { downloadFile };
